import { applyMiddleware, compose, createStore } from 'redux';

import reducer from './reducers/index';
import trackingMiddleware from './tracking-middleware';

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const store = createStore(
  reducer,
  composeEnhancers(applyMiddleware(trackingMiddleware))
);

export default store;



// WEBPACK FOOTER //
// ./app/javascript/apps/calculator/store.js